import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({

    bodyContainer: {
        width: '100vw',
        overflow: 'hidden',
        fontFamily: 'Noto Sans JP, sans-serif',
        color: '#333',
        scrollBehavior: 'smooth'
    },
    wrapSpan: {
        display: 'inline-block',
        // paddingRight: '0.5em',
    },

    
    sectionOrangeTitle: {
        background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,
        fontFamily: 'Noto Sans JP, sans-serif',
        fontStyle: 'normal',
        //   fontDisplay: 'swap',
        fontWeight: 500,
        maxWidth: '100%',
        padding: '0 .5em',
    },


    // ---------------
    // Q and A session
    // ---------------
    QA: {
        width: '100%',
        align: 'center',
        margin: '5rem auto 160px auto',
        // padding: '0px 60px',
    },
    questionDiv: {
        color: 'white',
        fontWeight: 500,
        width: '1000px',
        maxWidth: '100%',
        align: 'center',
        textAlign: 'left',
        background: '#F3923D',
        boxSizing: 'border-box',
        borderRadius: '15px',
        margin: '5rem auto 0.1rem auto',
        padding: '20px 20px',
        fontSize: '20px',

        display: 'flex',
        justifyItems: 'center',
    },
    questionIcon: {
        height: '35px',
        marginRight: '10px',

    },
    questionText: {
        fontSize: '20px',
    },
    answerDiv: {
        color: 'black',
        fontWeight: 300,
        width: '900px',
        maxWidth: '95%',
        align: 'center',
        textAlign: 'left',
        background: 'white',

        boxSizing: 'border-box',
        borderRadius: '15px',
        margin: '20px auto 0.1rem auto',
        padding: '20px 20px',
        fontSize: '16px',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        border: '2px solid #FFFFFF',
        display: 'flex',
        justifyItems: 'center',
    },
    answerIcon: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#F3923D',
        marginRight: '20px',
    },

}));